import { ActionControllerEventName, ResourcesManager, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import { Vector3 } from 'three';
import { PickingControllerEvents } from "@verybigthings/vbt-webvr-framework/build/main/ts/controls/PickingController";
import { PreparationPickingObjects } from "../../utils/PreparationPickingObjects";
export default class TestTubeHolderModule extends ViewerModule {
    constructor(level) {
        super();
        this.__inited = false;
        this.pointerController = Viewer.pointerController;
        this.model = ResourcesManager.getModel('micropipette_holder_3').clone();
        this.addObject(this.model);
        this.level = level;
    }
    init() {
        this.testTube1 = ResourcesManager.getModel('test_tube_empty').clone();
        this.testTube1.position.set(-.50, .16, 0);
        this.addObject(this.testTube1);
        this.testTube2 = ResourcesManager.getModel('test_tube_empty').clone();
        this.testTube2.position.set(0, .16, 0);
        this.addObject(this.testTube2);
        this.testTube3 = ResourcesManager.getModel('test_tube_empty').clone();
        this.testTube3.position.set(.51, .16, 0);
        this.addObject(this.testTube3);
    }
    createClickEvent() {
        let callback;
        this.actionController.on(ActionControllerEventName.click, this.uiObject, callback = () => {
            if (!this.level.interaction)
                return;
            this.fire('holder_clicked');
            this.actionController.off(ActionControllerEventName.click, this.uiObject, callback);
        });
        if (this.level.lobby.app.zSpacePickingController) {
            const pipetteUiObject = this.level.instruments.pipette.uiObject;
            PreparationPickingObjects.saveObjectState(pipetteUiObject);
            this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.RELEASED, pipetteUiObject, () => {
                const distanceToTesTubeHolder = this.level.instruments.pipette.model.getWorldPosition(new Vector3()).distanceTo(new Vector3(-23, -16.7, -12.7));
                if (distanceToTesTubeHolder < 1.3) {
                    this.fire('holder_clicked');
                    this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.PICKED, pipetteUiObject);
                    this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.RELEASED, pipetteUiObject);
                }
                else {
                    PreparationPickingObjects.flyObjectToPrevState(pipetteUiObject, 0);
                }
                setTimeout(() => pipetteUiObject.traverse(el => {
                    if (el.userData.oldRaycast)
                        el.raycast = el.userData.oldRaycast;
                }));
                this.actionController.off(ActionControllerEventName.click, this.uiObject, callback);
            });
        }
    }
    setEmptyTube() {
        this.disposeObject(this.testTube2);
        this.emptyTestTube = ResourcesManager.getModel('test_tube_red').clone();
        this.emptyTestTube.position.set(0, .16, 0);
        this.addObject(this.emptyTestTube);
    }
}
